import { atom } from 'recoil';

export const ratingStatusAtom = atom({
  key: 'ratingStatusAtom',
  default: 0,
});
